import { render, staticRenderFns } from "./paramsMail.vue?vue&type=template&id=042ead25"
import script from "./paramsMail.vue?vue&type=script&lang=ts"
export * from "./paramsMail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports